import { ReactNode, useState } from "react"
import cx from "classnames"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faXmark } from "@fortawesome/pro-solid-svg-icons"

export interface HorizontalImageNotificationProps {
  className?: string
  image: string
  alt?: string
  heading: string
  children: ReactNode
  closeable?: boolean
  variant?: "white" | "grass"
}

const HorizontalImageNotification = ({
  className,
  image,
  alt,
  heading,
  children,
  closeable = false,
  variant = "grass",
}: HorizontalImageNotificationProps) => {
  const [show, setShow] = useState<boolean>(true)

  if (!show) {
    return null
  }

  const bgClass = variant === "grass" ? "bg-grass-50" : "bg-white"

  return (
    <div
      className={cx(
        bgClass,
        "flex border-l-2 border-leaf rounded-r-sm shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] p-4",
        className
      )}
    >
      <figure className="w-[100px] flex items-center justify-center shrink-0">
        <img src={image} alt={alt} />
      </figure>

      <div className="grow">
        <div className="flex justify-between mb-2">
          <h3
            className="text-charcoal-500 text-base font-body font-bold leading-[150%] tracking-[0.32px]"
            data-testid="horizontal-image-notification-heading"
          >
            {heading}
          </h3>

          {closeable ? (
            <button
              onClick={() => setShow(false)}
              data-testid="horizontal-image-notification-close-btn"
            >
              <FontAwesomeIcon
                icon={faXmark}
                title={faXmark.iconName}
                className="pointer-events-none"
              />
            </button>
          ) : null}
        </div>

        {children}
      </div>
    </div>
  )
}

export default HorizontalImageNotification
